import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
        path: '/login',
        component: () =>
            import ('@/views/login/index'),
        hidden: true
    },
    {
        path: '/404',
        component: () =>
            import ('@/views/404'),
        hidden: true
    },
    {
        path: '',
        component: Layout,
        redirect: '/home',
        meta: { title: '首页', icon: 'home' },
        children: [{
                path: 'home',
                name: 'home',
                component: () =>
                    import ('@/views/category/index'),
                meta: { title: '游戏分类', icon: 'dashboard' },
            },
            {
                path: 'addCategory',
                name: 'addCategory',
                component: () =>
                    import ('@/views/category/add'),
                meta: { title: '添加游戏分类' },
                hidden: true
            },
            {
                path: 'updateCategory',
                name: 'updateCategory',
                component: () =>
                    import ('@/views/category/update'),
                meta: { title: '修改游戏分类' },
                hidden: true
            },


            {
                path: 'games',
                name: 'games',
                component: () =>
                    import ('@/views/games/index'),
                meta: { title: '游戏管理', icon: 'dashboard' },
            }, {
                path: 'addGames',
                name: 'addGames',
                component: () =>
                    import ('@/views/games/add'),
                meta: { title: '添加游戏' },
                hidden: true
            },
            {
                path: 'updateGames',
                name: 'updateGames',
                component: () =>
                    import ('@/views/games/update'),
                meta: { title: '修改游戏' },
                hidden: true
            },
            {
                path: 'banners',
                name: 'banners',
                component: () =>
                    import ('@/views/banners/index'),
                meta: { title: '轮播图管理', icon: 'dashboard' },
            },
            {
                path: 'addBanners',
                name: 'addBanners',
                component: () =>
                    import ('@/views/banners/add'),
                meta: { title: '添加轮播图' },
                hidden: true
            },
            {
                path: 'updateBanners',
                name: 'updateBanners',
                component: () =>
                    import ('@/views/banners/update'),
                meta: { title: '修改轮播图' },
                hidden: true
            },
            {
                path: 'member',
                name: 'member',
                component: () =>
                    import ('@/views/user/index'),
                meta: { title: '会员管理', icon: 'dashboard' },
            }
        ]
    }
]

export const asyncRouterMap = [{
        path: '/pms',
        component: Layout,
        redirect: '/pms/product',
        name: 'pms',
        meta: { title: '商品', icon: 'product' }
    },

    { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js